import React from 'react';
import styles from './SHRMButton.module.css';

type SHRMButtonProps = {
  className?: string;
  children: React.ReactNode;
  onClick?: any;
};

const SHRMButton = (props: SHRMButtonProps) => {
  return (
    <button
      className={`${styles.shrmButton} ${props.className ? props.className : ''}`}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
};

export default SHRMButton;
